import IAddress from "../entities/IAddress";
import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

export interface ICreateAddressPayload {
  addressId?: number | string;
  address1: string;
  address2?: string;
  stateCode?: string;
  stateName?: string;
  cityName: string;
  cityCode?: string;
  postcode?: string;
  phone: string;
  lng?: number | null;
  lat?: number | null;
  district?: string;
  userId: number;
}

const cityCodeFromName = (cityName: string): string =>
  cityName.trim().length >= 3 ? cityName.trim().substring(0, 3).toUpperCase() : "CTY";

const buildAddressPayload = (
  address: Partial<IAddress> & { userId: number }
): ICreateAddressPayload => ({
  addressId: address.addressId || "0",
  address1: address.address1 || "",
  address2: address.address2 || address.address1 || "",
  stateCode: address.stateCode || "PN",
  stateName: address.stateName || "",
  cityName: address.cityName || "",
  cityCode: address.cityCode || cityCodeFromName(address.cityName || ""),
  postcode: address.postCode || "",
  phone: address.phone || "",
  lng: null,
  lat: null,
  district: address.district || "",
  userId: address.userId,
});

const addAddress = (address: Partial<IAddress> & { userId: number }) => {
  return Axios.post<any>(ENDPOINTS.addresses.create, buildAddressPayload(address));
};

const updateAddress = (addressId: number, address: Partial<IAddress> & { userId: number }) => {
  return Axios.put<any>(ENDPOINTS.addresses.update(addressId), buildAddressPayload(address));
};

const deleteAddress = (addressId: number) => {
  return Axios.delete<any>(ENDPOINTS.addresses.delete(addressId));
};

const getAddressesByUser = (userId: number) => {
  return Axios.get<any>(ENDPOINTS.addresses.byUser(userId));
};

const setDefaultAddress = (addressId: number, userId: number) => {
  return Axios.patch<any>(ENDPOINTS.addresses.updateDefault, { addressId, userId });
};

const AddressService = {
  addAddress,
  updateAddress,
  deleteAddress,
  getAddressesByUser,
  setDefaultAddress,
};

export default AddressService;
